export const ALL = 'All' as const;
export const OTHER = 'Other' as const;

export type NavOrderMode = 'ALPHA' | 'MANUAL';
